module.exports = __webpack_public_path__ + "img/zt.bb49ddfb.svg";